import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {PivotQueryRequestData} from "../../framework/bi/pivot-query-request.data";

@Injectable()
export class PivotGridReportModel extends ReportModel<PivotQueryRequestData> {
    constructor(injector: Injector) {
        super(injector, PivotQueryRequestData);
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
